T.SideMenu = Class(
	/**
	 * @lends {T.SideMenu#}
	 */
	{
		__NAME: 'T.SideMenu',

		_items: {},
		_isOpen: false,

		__construct: function(par){
			par = par || {};

			this.node = mkE({
				tag: 'div',
				className: 'sidemenu',
				els: [
					{
						tag: 'div',
						className: 'sidemenu-active',
						onclick: this._toggle,
						els: [
							this._activeNode = mkE({
								tag: 'div',
								className: 'sidemenu-active-text'
							})
						]
					},
					this._itemsNode = mkE({
						tag: 'ul'
					})
				]
			});

			for( let i = 0, l = par.items.length; i < l; i++ ){
				let item = par.items[i];
				let link = mkE({
					tag: 'a',
					href: item.url,
					onclick: item.onclick || D.doNothing
				});
				mkE.appendTypeElement(link, item.caption);
				this._items[item.name] = mkE({
					tag: 'li',
					els: [
						link
					]
				}).append(this._itemsNode);
				if( par.active === item.name ){
					mkE.appendTypeElement(this._activeNode, item.caption);
				}
			}

			if( par.active && this._items[par.active] ){
				addClassName(this._items[par.active], 'active');
			}
		},

		_toggle: function(){
			if( this._isOpen ){
				removeClassName(this.node, 'sidemenu-open');
				this._isOpen = false;
			}else{
				addClassName(this.node, 'sidemenu-open');
				this._isOpen = true;
			}
		}
	},
	mkE.Base
);